module.exports = {
	"namespaces": [
		"403",
		"404",
		"500",
		"about",
		"auction",
		"billing",
		"buying",
		"categories",
		"claim",
		"comingSoon",
		"contact",
		"currency",
		"dashboard",
		"email",
		"emailTemplate",
		"errors",
		"features",
		"footer",
		"general",
		"help",
		"home",
		"increments",
		"invoice",
		"language",
		"login",
		"lot",
		"management",
		"menu",
		"organization",
		"password",
		"paymentHistory",
		"paymentMethods",
		"payments",
		"phone",
		"press",
		"pricing",
		"privacy",
		"routes",
		"selling",
		"subscription",
		"terminology",
		"terms",
		"upload",
		"widget-common",
		"oa-ajax",
		"oa-auction",
		"oa-logo",
		"oa-lot",
		"oa-settings",
		"oa-staffAccess"
	]
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/locales/namespaces.json5
// module id = 1913
// module chunks = 6